var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./CommonStoryVideo.jinja');
require('./CommonStoryVideo.less');

var CommonVideoPlayer = require('front/components/CommonVideoPlayer/CommonVideoPlayer');


module.exports = Base.extend({

    template: template,


    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'CommonVideoPlayer': {selector: '.CommonVideoPlayer', viewConstructor: CommonVideoPlayer}
    },


    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    }

});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonStory/CommonStoryVideo.js
// module id = 176
// module chunks = 0